/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ArtifactWidgetListingsSearchContent } from './ArtifactWidgetListingsSearchContent';
import {
    ArtifactWidgetListingsSearchContentFromJSON,
    ArtifactWidgetListingsSearchContentFromJSONTyped,
    ArtifactWidgetListingsSearchContentToJSON,
    ArtifactWidgetListingsSearchContentToJSONTyped,
} from './ArtifactWidgetListingsSearchContent';

/**
 * 
 * @export
 * @interface ArtifactActiveWidgetContext
 */
export interface ArtifactActiveWidgetContext {
    /**
     * 
     * @type {string}
     * @memberof ArtifactActiveWidgetContext
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactActiveWidgetContext
     */
    messageId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArtifactActiveWidgetContext
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactActiveWidgetContext
     */
    updatedAt: string;
    /**
     * 
     * @type {string}
     * @memberof ArtifactActiveWidgetContext
     */
    kind: ArtifactActiveWidgetContextKindEnum;
    /**
     * 
     * @type {ArtifactWidgetListingsSearchContent}
     * @memberof ArtifactActiveWidgetContext
     */
    content: ArtifactWidgetListingsSearchContent;
}


/**
 * @export
 */
export const ArtifactActiveWidgetContextKindEnum = {
    ActiveWidgetContext: 'active-widget-context'
} as const;
export type ArtifactActiveWidgetContextKindEnum = typeof ArtifactActiveWidgetContextKindEnum[keyof typeof ArtifactActiveWidgetContextKindEnum];


/**
 * Check if a given object implements the ArtifactActiveWidgetContext interface.
 */
export function instanceOfArtifactActiveWidgetContext(value: object): value is ArtifactActiveWidgetContext {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('messageId' in value) || value['messageId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function ArtifactActiveWidgetContextFromJSON(json: any): ArtifactActiveWidgetContext {
    return ArtifactActiveWidgetContextFromJSONTyped(json, false);
}

export function ArtifactActiveWidgetContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArtifactActiveWidgetContext {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'messageId': json['messageId'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'kind': json['kind'],
        'content': ArtifactWidgetListingsSearchContentFromJSON(json['content']),
    };
}

export function ArtifactActiveWidgetContextToJSON(json: any): ArtifactActiveWidgetContext {
    return ArtifactActiveWidgetContextToJSONTyped(json, false);
}

export function ArtifactActiveWidgetContextToJSONTyped(value?: ArtifactActiveWidgetContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'messageId': value['messageId'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'kind': value['kind'],
        'content': ArtifactWidgetListingsSearchContentToJSON(value['content']),
    };
}

